import { apiClient } from '@/core/infra_api_client'

// ============= Types =============

export interface ChartVersion {
  name: string
  version: string
  appVersion: string
  description: string
  created: string
  digest: string
}

export interface DeployedChart {
  id: string
  environmentId: string
  environmentName: string
  releaseName: string
  chartVersion: string
  status: string
  revision: number
  updatedAt: string
}

export interface ChartDeviation {
  environmentId: string
  environmentName: string
  releaseName: string
  currentVersion: string
  latestVersion: string
  deviationType: 'outdated' | 'unknown_version'
}

// ============= API =============

const BASE_PATH = 'charts'

export async function listChartVersions(): Promise<ChartVersion[]> {
  return apiClient.get<ChartVersion[]>(`${BASE_PATH}/versions`)
}

export async function getLatestChartVersion(): Promise<ChartVersion> {
  return apiClient.get<ChartVersion>(`${BASE_PATH}/versions/latest`)
}

export async function listDeployedCharts(): Promise<DeployedChart[]> {
  return apiClient.get<DeployedChart[]>(`${BASE_PATH}/deployed`)
}

export async function listChartDeviations(): Promise<ChartDeviation[]> {
  return apiClient.get<ChartDeviation[]>(`${BASE_PATH}/deviations`)
}

export async function refreshChartDeviations(): Promise<{ deviationsFound: number; status: string }> {
  return apiClient.post<{ deviationsFound: number; status: string }, undefined>(
    `${BASE_PATH}/deviations/refresh`,
    undefined,
  )
}
